import { loadState } from "localStorage";

export const getSessionToken = (): string => {
  const state = loadState();
  return state?.sessionToken || "";
};
